import { assertEx } from '@xylabs/sdk-js'

import { RebillyCreatePaymentToken, RebillyPaymentMethod } from '../rebilly'
import { expiryMonth } from './expiryMonth'
import { expiryYear } from './expiryYear'
import { ProcessPaymentParams } from './ProcessPaymentParams'

export const createPaymentTokenParams = (params: ProcessPaymentParams): RebillyCreatePaymentToken => {
  return {
    billingAddress: { firstName: params.customer?.firstName, lastName: params.customer?.lastName, ...params.billing },
    method: RebillyPaymentMethod.card,
    paymentInstrument: {
      cvv: assertEx(params?.paymentInfo?.cvc, 'Missing cvc'),
      expMonth: expiryMonth(params?.paymentInfo?.expiry ?? ''),
      expYear: expiryYear(params?.paymentInfo?.expiry ?? ''),
      pan: params?.paymentInfo?.creditcard ?? '',
    },
    sandbox: params.sandbox,
  }
}
